module.exports = __webpack_public_path__ + "media/parking_0.dfb05443.mp4";